export const REFERENCE_TYPE_TECHNIQUE = 'Technique';

export const LISTE_REFERENCE_TYPE = [
  { libelle: 'addEditNomenclatureType.reference.technique', code: REFERENCE_TYPE_TECHNIQUE },
];
